import { PageOptions } from '@graphcommerce/framer-next-pages'

import { flushMeasurePerf } from '@graphcommerce/graphql'
import {
  CategoryChildren,
  CategoryMeta,
  getCategoryStaticPaths,
} from '@graphcommerce/magento-category'
import {
  extractUrlQuery,
  FilterTypes,
  getFilterTypes,
  ProductFiltersDocument,
  ProductFiltersQuery,
  ProductListDocument,
  ProductListFilters,
  ProductListParams,
  ProductListParamsProvider,
  ProductListQuery,
} from '@graphcommerce/magento-product'
import { StoreConfigDocument, redirectOrNotFound } from '@graphcommerce/magento-store'
import {
  LayoutTitle,
  GetStaticProps,
  MetaRobots,
} from '@graphcommerce/next-ui'
import { Container, Hidden } from '@mui/material'
import { GetStaticPaths } from 'next'

import {
  DevLayoutNavigation,
  LayoutNavigationProps,
  ProductListItems,
  RowProduct,
  RowRenderer,
} from '../components'

import AjaxProducts from '../components/AjaxProducts'
import { LayoutDocument } from '../components/Layout/Layout.gql'
import FilterByStockStatus from '../components/ProductList/FilterByStockStatus'
import ProductListDescription from '../components/ProductList/ProductListDescription'
import { ProductListLimit } from '../components/ProductList/ProductListLimit'
import ProductListPagination from '../components/ProductList/ProductListPagination'
import ProductListScripts from '../components/ProductList/ProductListScripts'
import BottomNavigationBar from '../components/bottomNavigationBar'
import ProductListItemsBody from '../components/customLayout/ProductListItemsBody'
import SectionHeader from '../components/customLayout/SectionHeader'
import MainContentLayout from '../components/customLayout/mainContentLayout'
import Icon348Filter from '../components/icons/Icon348Filter'
import IconArrowDownUp from '../components/icons/IconArrowDownUp'
import IconArrowLeftShort from '../components/icons/IconArrowLeftShort'
import { ProductListSort } from '../components/productListSort';
import ProductSortLayout from '../components/widgets/ProductSortLayout'
import { CategoryPageDocument, CategoryPageQuery } from '../graphql/CategoryPage.gql'
import { MegaMenuContentDocument } from '../graphql/MegaMenuContent.gql'
import { storeLogoDocument } from '../graphql/storeLogo.gql'
import { graphqlSsrClient, graphqlSharedClient } from '../lib/graphql/graphqlSsrClient'
import { parseParams } from '../lib/parseParams'

export type CategoryProps = CategoryPageQuery &
  ProductListQuery &
  ProductFiltersQuery & { filterTypes?: FilterTypes; params?: ProductListParams }



export type CategoryRoute = { url: string[] }

type GetPageStaticPaths = GetStaticPaths<CategoryRoute>
type GetPageStaticProps = GetStaticProps<LayoutNavigationProps, CategoryProps, CategoryRoute>

function CategoryPage(props: CategoryProps) {
  const { categories, products, filters, params, filterTypes, pages } = props


  const category = categories?.items?.[0]
  const isLanding = category?.display_mode === 'PAGE'
  const page = pages?.[0]
  const isCategory = params && category && products?.items && filterTypes

  const filterItems = ['محبوبیت', 'امتیاز', 'جدیدترین', 'ارزانترین', 'گرانترین', 'موجودی', ' پرفروش ترین', 'به زودی']

  return (
    <MainContentLayout>
      <CategoryMeta
        params={params}
        title={page?.metaTitle}
        metaDescription={page?.metaDescription}
        metaRobots={page?.metaRobots.toLowerCase().split('_') as MetaRobots[]}
        canonical={page?.url ? `/${page.url}` : undefined}
        {...category}
      />
      {/* <LayoutHeader floatingMd>
        <LayoutTitle size='small' component='span'>
          {category?.name ?? page.title}
        </LayoutTitle>
      </LayoutHeader> */}
      {!isLanding && (
        <Container maxWidth={false}>
          <LayoutTitle
            variant='h1'
            gutterTop
            sx={(theme) => ({
              marginBottom: category?.description && theme.spacings.md,
            })}
            gutterBottom={
              !isCategory || (!category?.description && category?.children?.length === 0)
            }
          >
            {category?.name ?? page.title}
          </LayoutTitle>
        </Container>
      )}

      {isCategory && !isLanding && (
        <>
          {/*           <CategoryDescription description={category.description} />
 */}
          <div className='w-full  flex flex-row align-top items-stretch relative'>

            {/* <div className='fixed bottom-0 right-0 left-0 shadow-md bg-white flex py-5 box-border 992:hidden z-[20] 992:z-[-1]'>

              <div className='flex-1 w-[50%] text-sm flex items-center justify-center cursor-pointer text-primary-500' id="showSortBtn">
                <IconArrowDownUp width={18} height={18} className='ml-3' />
                <span className='text-sm font-medium'>مرتب‌سازی</span>
              </div>
              <div className='flex-1 w-[50%] text-sm flex items-center justify-center cursor-pointer text-primary-500' id="showFilterBtn">
                <Icon348Filter width={18} height={18} className='ml-3' />
                <span className='text-sm font-medium'>فیلترها</span>
              </div>
            </div> */}
            <Hidden mdUp>


              <BottomNavigationBar />
            </Hidden>

            <div className=' w-full 992:w-[25%] bg-white hidden 992:block fixed top-0 right-0 left-0 bottom-0 992:absolute 992:right-0 992:left-auto 992:bottom-auto 992:top-0 overflow-auto small-scrollbar z-[-1] md:z-auto' id="FiltersSection">


              <div className=' m-auto pb-[100px] md:pb-[0] w-[95%] overflow-scroll hidden-scroll-bar max-h-screen md:max-h-max'>
                <ProductListParamsProvider value={params}>
                  <ProductListFilters {...filters} filterTypes={filterTypes} />
                  <Hidden mdUp>
                    <FilterByStockStatus />
                  </Hidden>
                </ProductListParamsProvider>
              </div>
              <Hidden smUp>

                <div className='text-sm flex fixed right-0 left-0 shadow-2xl h-14 bg-white bottom-0 items-center justify-center cursor-pointer text-primary-500' id="applyFilterBtn">
                  <Icon348Filter width={18} height={18} className='ml-3' />
                  <span className='text-sm font-medium'>اعمال فیلترها</span>
                </div>
              </Hidden>

            </div>

            <div className=' w-[100%] 992:w-[70%]  mx-auto md:ml-0 h-[100%] md:min-h-[992px] flex flex-col align-top justify-start'>
              {import.meta.graphCommerce.productFiltersPro ? null : (
                <ProductListParamsProvider value={params}>
                  <CategoryChildren params={params}>{category.children}</CategoryChildren>
                  <Hidden mdDown>
                    <div className='flex flex-row items-center gap-1 justify-between w-full p-4'>
                      <div className='flex flex-row text-default-400 justify-start gap-3 items-center text-xs'>
                        <span >مرتب سازی بر اساس:</span>
                        {filterItems.map((item, index) => <p className={index === 1 ? `cursor-pointer p-2 rounded-lg bg-secondary-500 text-white` : `cursor-pointer p-2 rounded-lg hover:bg-light-200 hover:text-white  text-default-400`} key={item}>{item}</p>)}
                      </div>
                      <FilterByStockStatus />
                      {/* <ProductListSort
                              sort_fields={products?.sort_fields}
                              total_count={products?.total_count}
                            /> */}
                    </div>
                  </Hidden>
                  <ProductSortLayout
                    sort_fields={products?.sort_fields}
                  />
                </ProductListParamsProvider>
              )}
              {/*                   {products?.page_info?.total_pages > 1 && <Pagination params={params} count={products.page_info?.total_pages} page={products?.page_info?.current_pages} />}
 */}

              <ProductListItemsBody>
                {/* <ProductListCount total_count={products?.total_count} /> */}
                {/* <ProductListPagination page_info={products?.page_info} params={params} /> */}
                <ProductListItems
                  title={category.name ?? ''}
                  items={products?.items}
                  loadingEager={1}
                />
                <Hidden mdUp>

                  <AjaxProducts {...category} />
                </Hidden>
              </ProductListItemsBody>
              <Hidden mdDown>

                <SectionHeader className='w-full titleLayout flex flex-row  h-10 justify-end mt-0 p-1' >
                  <ProductListPagination page_info={products?.page_info} params={params} />

                </SectionHeader>
              </Hidden>
            </div>
            {/* <ProductListPagination page_info={products?.page_info} params={params} /> */}
          </div>


          <ProductListDescription description={category?.description} />
        </>
      )}


      {
        page && (
          <RowRenderer
            content={page.content}
            renderer={{
              RowProduct: (rowProps) => (
                <RowProduct
                  {...rowProps}
                  {...products?.items?.[0]}
                  items={products?.items?.slice(0, 8)}
                />
              ),
            }}
          />
        )
      }

      <ProductListScripts />
    </MainContentLayout>
  )
}

const pageOptions: PageOptions<LayoutNavigationProps> = {
  Layout: DevLayoutNavigation,
}
CategoryPage.pageOptions = pageOptions

export default CategoryPage

export const getStaticPaths: GetPageStaticPaths = async ({ locales = [] }) => {
  // Disable getStaticPaths while in development mode
  if (process.env.NODE_ENV === 'development') return { paths: [], fallback: 'blocking' }

  const path = (loc: string) => getCategoryStaticPaths(graphqlSsrClient(loc), loc)
  const paths = (await Promise.all(locales.map(path))).flat(1)
  return { paths, fallback: 'blocking' }
}

export const getStaticProps: GetPageStaticProps = async ({ params, locale }) => {
  const [url, query] = extractUrlQuery(params);

  if (!url || !query) return { notFound: true }

  const client = graphqlSharedClient(locale)
  const conf = client.query({ query: StoreConfigDocument })
  const filterTypes = getFilterTypes(client)
  const staticClient = graphqlSsrClient(locale)

  const categoryPage = staticClient.query({
    query: CategoryPageDocument,
    variables: { url },
  })
  const layout = staticClient.query({ query: LayoutDocument, fetchPolicy: 'cache-first' })
  const menuContent = staticClient.query({ query: MegaMenuContentDocument });
  const storeLogo = staticClient.query({ query: storeLogoDocument });
  const productListParams = parseParams(url, query, await filterTypes);

  const filteredCategoryUid = productListParams && productListParams.filters.category_uid?.in?.[0]



  let categoryUid = filteredCategoryUid
  if (!categoryUid) {
    categoryUid = (await categoryPage).data.categories?.items?.[0]?.uid ?? ''
    if (productListParams) productListParams.filters.category_uid = { in: [categoryUid] }
  }

  const hasPage = filteredCategoryUid ? false : (await categoryPage).data.pages.length > 0
  const hasCategory = Boolean(productListParams && categoryUid)

  if (!productListParams || !(hasPage || hasCategory))
    return redirectOrNotFound(staticClient, conf, params, locale)

  if (!hasCategory) {
    return {
      props: {
        ...(await categoryPage).data,
        ...(await layout).data,
        ...(await menuContent).data,
        apolloState: await conf.then(() => client.cache.extract()),
      },
      revalidate: 60 * 2,
    }
  }

  const filters = staticClient.query({
    query: ProductFiltersDocument,
    variables: { filters: { category_uid: { eq: categoryUid } } },
  })

  const products = staticClient.query({
    query: ProductListDocument,
    variables: {
      pageSize: productListParams.pageSize ?? 16,
      ...productListParams,
      filters: { ...productListParams.filters, category_uid: { eq: categoryUid } },
      sort: productListParams.sort
    },
  })

  if ((await products).errors) return { notFound: true }

  const { category_name, category_url_path } =
    (await categoryPage).data.categories?.items?.[0]?.breadcrumbs?.[0] ?? {}

  const up =
    category_url_path && category_name
      ? { href: `/${category_url_path}`, title: category_name }
      : { href: `/`, title: 'Home' }

  const result = {
    props: {
      ...(await categoryPage)?.data,
      ...(await products)?.data,
      ...(await filters)?.data,
      ...(await layout)?.data,
      ...(await menuContent)?.data,
      ...(await storeLogo)?.data,

      filterTypes: await filterTypes,

      params: productListParams,
      apolloState: await conf.then(() => client.cache.extract()),
      up,
    },
    revalidate: 60 * 2,
  }
  flushMeasurePerf()
  return result
}


